var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Linesheets_Logo_-_Black",
    "data-name": "Linesheets Logo - Black",
    width: 543,
    height: 114,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 544.081,
    height: 113.497,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.406,
    y1: 0.607,
    x2: 0.868,
    y2: 0.082,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d1c1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#373735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    stopColor: "#626160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#515150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    stopColor: "#282827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.091,
    y1: 0.909,
    x2: 0.909,
    y2: 0.091,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.091,
    y1: 0.909,
    x2: 0.909,
    y2: 0.091,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.258,
    y1: 0.741,
    x2: 0.53,
    y2: 0.469,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39872",
    "data-name": "Path 39872",
    d: "M685.858,293.334c-25.3-24.657-75.555-16.405-79.011-16.812-9.435-1.111-6.407-13.036-4.92-19.874,6.2-28.53-.333-55.026-8.049-60.317C601.1,201.281,668.117,267.211,685.858,293.334Z",
    transform: "translate(-593.879 -196.332)",
    fill: "#262626",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.073,
    y1: 0.927,
    x2: 0.49,
    y2: 0.51,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_1_20",
    "data-name": "Component 1 \\u2013 20",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18337",
    "data-name": "Group 18337",
    transform: "translate(138.219 23.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39494",
    "data-name": "Path 39494",
    d: "M195.646,132.494h11.867v65.555H195.646Z",
    transform: "translate(-195.646 -131.277)",
    fill: "#040505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39495",
    "data-name": "Path 39495",
    d: "M215.489,131.66a7.256,7.256,0,0,1,5.354,2.259,7.508,7.508,0,0,1,2.233,5.477,7.421,7.421,0,0,1-2.21,5.412,7.175,7.175,0,0,1-5.289,2.24,7.278,7.278,0,0,1-5.4-2.283,7.636,7.636,0,0,1-2.232-5.543,7.557,7.557,0,0,1,7.541-7.563Zm-5.933,19.474h11.867v47.3H209.556Z",
    transform: "translate(-189.993 -131.66)",
    fill: "#040505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39496",
    "data-name": "Path 39496",
    d: "M223.348,145.386h11.869v4.848a28.443,28.443,0,0,1,7.314-4.735,17.674,17.674,0,0,1,6.706-1.331,16.237,16.237,0,0,1,11.939,4.913q4.122,4.173,4.123,12.346v31.257H253.561V171.971q0-8.466-.759-11.245a7.7,7.7,0,0,0-2.646-4.232,7.4,7.4,0,0,0-4.662-1.455,8.734,8.734,0,0,0-6.18,2.41,12.863,12.863,0,0,0-3.579,6.665,53.745,53.745,0,0,0-.52,9.6v18.975H223.348Z",
    transform: "translate(-182.917 -125.912)",
    fill: "#040505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39497",
    "data-name": "Path 39497",
    d: "M306.816,172.47H268.691a12.7,12.7,0,0,0,4.412,8.02,13.848,13.848,0,0,0,9.151,2.977,15.824,15.824,0,0,0,11.434-4.651l10,4.7a23.608,23.608,0,0,1-8.954,7.846,28,28,0,0,1-12.39,2.544q-11.13,0-18.128-7.022a23.889,23.889,0,0,1-7-17.584q0-10.824,6.978-17.975a23.431,23.431,0,0,1,17.5-7.152q11.172,0,18.171,7.152t7,18.889Zm-11.867-9.347a11.912,11.912,0,0,0-4.638-6.434,13.446,13.446,0,0,0-8.034-2.478,14.217,14.217,0,0,0-8.709,2.782,15.5,15.5,0,0,0-4.354,6.13Z",
    transform: "translate(-167.355 -125.912)",
    fill: "#040505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39498",
    "data-name": "Path 39498",
    d: "M326.692,151.995l-7.347,7.346q-4.477-4.433-8.13-4.434a5.116,5.116,0,0,0-3.129.848,2.549,2.549,0,0,0-1.131,2.109,2.592,2.592,0,0,0,.717,1.76,13.416,13.416,0,0,0,3.543,2.2l4.348,2.173q6.868,3.391,9.433,6.912a14.4,14.4,0,0,1-2.065,18.779q-4.63,4.219-12.41,4.218A19.732,19.732,0,0,1,294,185.816l7.3-7.956a16.887,16.887,0,0,0,4.891,3.935,10.847,10.847,0,0,0,4.978,1.5,5.94,5.94,0,0,0,3.782-1.13,3.278,3.278,0,0,0,1.435-2.608q0-2.739-5.174-5.348l-4-2q-11.476-5.782-11.476-14.477a12.557,12.557,0,0,1,4.324-9.585,15.707,15.707,0,0,1,11.064-3.979,19.191,19.191,0,0,1,15.563,7.826Z",
    transform: "translate(-150.452 -125.912)",
    fill: "#040505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40098",
    "data-name": "Path 40098",
    d: "M326.692,151.995l-7.347,7.346q-4.477-4.433-8.13-4.434a5.116,5.116,0,0,0-3.129.848,2.549,2.549,0,0,0-1.131,2.109,2.592,2.592,0,0,0,.717,1.76,13.416,13.416,0,0,0,3.543,2.2l4.348,2.173q6.868,3.391,9.433,6.912a14.4,14.4,0,0,1-2.065,18.779q-4.63,4.219-12.41,4.218A19.732,19.732,0,0,1,294,185.816l7.3-7.956a16.887,16.887,0,0,0,4.891,3.935,10.847,10.847,0,0,0,4.978,1.5,5.94,5.94,0,0,0,3.782-1.13,3.278,3.278,0,0,0,1.435-2.608q0-2.739-5.174-5.348l-4-2q-11.476-5.782-11.476-14.477a12.557,12.557,0,0,1,4.324-9.585,15.707,15.707,0,0,1,11.064-3.979,19.191,19.191,0,0,1,15.563,7.826Z",
    transform: "translate(75.548 -125.912)",
    fill: "#040505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39499",
    "data-name": "Path 39499",
    d: "M322.21,132.494h11.78v23.04a27.043,27.043,0,0,1,7-4.5,18.051,18.051,0,0,1,7.13-1.5,16.061,16.061,0,0,1,11.867,4.869q4.131,4.219,4.13,12.39v31.257h-11.7V177.312q0-8.216-.782-11.129a7.755,7.755,0,0,0-2.674-4.346,7.5,7.5,0,0,0-4.672-1.435,8.813,8.813,0,0,0-6.2,2.391,12.669,12.669,0,0,0-3.586,6.521q-.521,2.13-.523,9.738v19H322.21Z",
    transform: "translate(-137.49 -131.277)",
    fill: "#040505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39500",
    "data-name": "Path 39500",
    d: "M405.646,172.47H367.522a12.689,12.689,0,0,0,4.412,8.02,13.847,13.847,0,0,0,9.151,2.977,15.82,15.82,0,0,0,11.432-4.651l10,4.7a23.6,23.6,0,0,1-8.954,7.846,28,28,0,0,1-12.39,2.544q-11.128,0-18.127-7.022a23.89,23.89,0,0,1-7-17.584q0-10.824,6.976-17.975a23.436,23.436,0,0,1,17.5-7.152q11.172,0,18.169,7.152t7,18.889Zm-11.866-9.347a11.9,11.9,0,0,0-4.638-6.434,13.447,13.447,0,0,0-8.034-2.478,14.21,14.21,0,0,0-8.709,2.782,15.484,15.484,0,0,0-4.354,6.13Z",
    transform: "translate(-121.943 -125.912)",
    fill: "#040505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39501",
    "data-name": "Path 39501",
    d: "M443.475,172.47H405.351a12.7,12.7,0,0,0,4.411,8.02,13.851,13.851,0,0,0,9.152,2.977,15.823,15.823,0,0,0,11.432-4.651l10,4.7a23.6,23.6,0,0,1-8.955,7.846A28,28,0,0,1,419,193.9q-11.128,0-18.127-7.022a23.884,23.884,0,0,1-7-17.584q0-10.824,6.976-17.975a23.436,23.436,0,0,1,17.5-7.152q11.174,0,18.171,7.152t7,18.889Zm-11.867-9.347a11.9,11.9,0,0,0-4.637-6.434,13.454,13.454,0,0,0-8.035-2.478,14.211,14.211,0,0,0-8.709,2.782,15.485,15.485,0,0,0-4.355,6.13Z",
    transform: "translate(-104.56 -125.912)",
    fill: "#040505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39502",
    "data-name": "Path 39502",
    d: "M436.122,133.06h11.867v17.431h7.042v10.216h-7.042v37.081H436.122V160.707h-6.086V150.491h6.086Z",
    transform: "translate(-87.944 -131.017)",
    fill: "#040505"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18681",
    "data-name": "Group 18681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39874",
    "data-name": "Path 39874",
    d: "M27.743,0H80.384c15.322,0,27.743,12.961,27.743,28.949v55.4c0,15.988-12.421,28.948-27.742,28.948H27.743C12.421,113.3,0,100.338,0,84.35v-55.4C0,12.961,12.421,0,27.743,0Z",
    transform: "translate(0.039 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39875",
    "data-name": "Path 39875",
    d: "M3.589,0h15.5a3.589,3.589,0,0,1,3.589,3.589V19.094A3.586,3.586,0,0,1,19.1,22.68H3.586A3.586,3.586,0,0,1,0,19.094V3.589A3.589,3.589,0,0,1,3.589,0Z",
    transform: "translate(13.132 46.66)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39876",
    "data-name": "Path 39876",
    d: "M3.586,0H19.093a3.589,3.589,0,0,1,3.589,3.589V19.094A3.586,3.586,0,0,1,19.1,22.68H3.586A3.586,3.586,0,0,1,0,19.094V3.586A3.586,3.586,0,0,1,3.586,0Z",
    transform: "translate(13.132 77.733)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39877",
    "data-name": "Path 39877",
    d: "M3.586,0H19.094a3.588,3.588,0,0,1,3.588,3.588V19.094A3.586,3.586,0,0,1,19.1,22.68H3.589A3.589,3.589,0,0,1,0,19.091V3.586A3.586,3.586,0,0,1,3.586,0Z",
    transform: "translate(41.801 77.733)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18681-2",
    "data-name": "Group 18681",
    transform: "translate(13.132 14.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39878",
    "data-name": "Path 39878",
    d: "M7.061,0h8.558a7.063,7.063,0,0,1,7.063,7.063v8.554a7.063,7.063,0,0,1-7.063,7.063H7.063A7.063,7.063,0,0,1,0,15.617V7.061A7.061,7.061,0,0,1,7.061,0Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39879",
    "data-name": "Path 39879",
    d: "M7.061,0H15.62a7.062,7.062,0,0,1,7.062,7.062v8.555a7.063,7.063,0,0,1-7.063,7.063H7.063A7.063,7.063,0,0,1,0,15.617V7.061A7.061,7.061,0,0,1,7.061,0Z",
    transform: "translate(28.671 0)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39881",
    "data-name": "Path 39881",
    d: "M7.061,0h8.557a7.063,7.063,0,0,1,7.063,7.063v8.554a7.063,7.063,0,0,1-7.063,7.063H7.063A7.063,7.063,0,0,1,0,15.617V7.061A7.061,7.061,0,0,1,7.061,0Z",
    transform: "translate(57.341 0)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39880",
    "data-name": "Path 39880",
    d: "M7.061,0H15.62a7.062,7.062,0,0,1,7.062,7.062v8.555a7.063,7.063,0,0,1-7.063,7.063H7.063A7.063,7.063,0,0,1,0,15.617V7.061A7.061,7.061,0,0,1,7.061,0Z",
    transform: "translate(28.671 31.131)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39882",
    "data-name": "Path 39882",
    d: "M7.061,0h8.557a7.063,7.063,0,0,1,7.063,7.063V15.62A7.061,7.061,0,0,1,15.62,22.68H7.063A7.063,7.063,0,0,1,0,15.617V7.061A7.061,7.061,0,0,1,7.061,0Z",
    transform: "translate(57.341 31.131)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39883",
    "data-name": "Path 39883",
    d: "M7.061,0h8.557a7.063,7.063,0,0,1,7.063,7.063V15.62A7.061,7.061,0,0,1,15.62,22.68H7.063A7.063,7.063,0,0,1,0,15.617V7.061A7.061,7.061,0,0,1,7.061,0Z",
    transform: "translate(57.341 62.261)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_39870",
    "data-name": "Path 39870",
    d: "M590.96,196.332a29.451,29.451,0,0,0-9.523,21.795v55.56c0,16.035,12.421,29.031,27.743,29.031h52.641A27.192,27.192,0,0,0,682.9,292.545Z",
    transform: "translate(-581.437 -189.221)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18683",
    "data-name": "Group 18683",
    transform: "translate(9.526 7.112)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39871",
    "data-name": "Path 39871",
    d: "M685.858,293.334c-25.3-24.657-75.555-16.405-79.011-16.812-9.435-1.111-6.407-13.036-4.92-19.874,6.2-28.53-.333-55.026-8.049-60.317C601.1,201.281,668.117,267.211,685.858,293.334Z",
    transform: "translate(-593.879 -196.332)",
    fill: "#262626",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18682",
    "data-name": "Group 18682",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2757",
    "data-name": "Rectangle 2757",
    d: "M41.652,0H82.614a41.655,41.655,0,0,1,41.655,41.655V89.517a41.655,41.655,0,0,1-41.655,41.655H41.656A41.656,41.656,0,0,1,0,89.516V41.652A41.652,41.652,0,0,1,41.652,0Z",
    transform: "translate(-32.445 0.31)",
    fill: "#262626"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39873",
    "data-name": "Path 39873",
    d: "M594.055,196.391c.064.051,57.7,60.711,92.18,96.957-20.12-20.624-76.84-15.07-80.352-15.483-9.123-1.073-6.519-12.78-5.082-19.391C608.463,223.211,594.055,196.391,594.055,196.391Z",
    transform: "translate(-584.393 -189.235)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e5c471e4475dde6ee88da9e761b2b363.svg";
export { ForwardRef as ReactComponent };